import { Injectable, signal } from '@angular/core';

/**
 * A feira sobre a qual o console está operando **agora**.
 *
 * O console não tem feira ativa: ele atravessa todas. Mas configurar,
 * desenhar a planta e consultar os acessos de uma feira são operações **sobre
 * uma feira**, e a API escopa por `x-event-id`. Por isso o valor é `null` em
 * toda tela transversal — chamados, pedidos, lista de feiras, comunicados — e
 * só existe enquanto uma feira está em foco.
 *
 * 🔴 **Quem sai da feira em foco precisa limpar isto.** Um id que sobrevive
 * faz a caixa de chamados voltar filtrada por uma feira, sem nada na tela
 * dizendo isso. A moldura da feira limpa ao ser destruída; há teste de
 * regressão em `inspected-event.spec.ts`.
 */
@Injectable({ providedIn: 'root' })
export class InspectedEvent {
	readonly #id = signal<string | null>(null);
	readonly id = this.#id.asReadonly();

	focus(eventId: string): void {
		this.#id.set(eventId);
	}

	clear(): void {
		this.#id.set(null);
	}
}
